import { DocumentsPage, PageHead, SeoFooter } from '@/components'

const Documents = ({ data }) => {
    return (
        <>
            <PageHead meta={data.seo_meta}/>
            <DocumentsPage title={data.title} docs={data.docs} />
            <div className="containerDocs">
                Раскрытие информации (финансовая документация) размещается на основном сайте ООО «Ювилс Лизинг» по ссылке{' '}
                <a href=" https://yoowills.by/documents/" target="_blank">
                     https://yoowills.by/documents/
                </a>.
            </div>
            {data.seo_meta.addtional_description && <SeoFooter text={data.seo_meta.addtional_description} />}
        </>
    )
}

Documents.getInitialProps = async ({ api }) => {
    const { data } = await api.pageWithSlug('docs')()

    return { data: data }
}

export default Documents
